export function renderTabsTriggerTabsLayoutTemplate({
  indent,
  tabName,
  className,
  iconName,
  tabLabel
}: {
  indent: string
  tabName: string
  className: string
  iconName: string
  tabLabel: string
}): string {
  return `${indent}<TabsTrigger value="${tabName}"${className}>
${indent}  <${iconName} className="size-4 shrink-0" />
${indent}  <span>${tabLabel}</span>
${indent}</TabsTrigger>`
}
